import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContactComponent } from './contact/contact.component';
import { ScheduleDemoComponent } from './schedule-demo/schedule-demo.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PartnerComponent } from './partner/partner.component';
import { CampaignComponent } from './campaign/campaign.component';
import { ResourcesComponent } from './resources/resources.component';
import { PostsComponent } from './posts/posts.component';
import { WhitepapersComponent } from './whitepapers/whitepapers.component';
import { PocDetailComponent } from './poc-detail/poc-detail.component';
import { QuillModule } from 'ngx-quill';
import { CoursePackageComponent } from './course-package/course-package.component';
import { WebinarComponent } from './webinar/webinar.component';
import { EventsComponent } from './events/events.component';

@NgModule({
  declarations: [
    AppComponent,
    ContactComponent,
    ScheduleDemoComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    PartnerComponent,
    CampaignComponent,
    ResourcesComponent,
    PostsComponent,
    WhitepapersComponent,
    PocDetailComponent,
    CoursePackageComponent,
    WebinarComponent,
    EventsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    QuillModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent],
  exports:[QuillModule]
})
export class AppModule { }
